// extracted by mini-css-extract-plugin
export default {"change":"ChangePassword_change__W41kH","change__instruction":"ChangePassword_change__instruction__O2dJQ","change__submit":"ChangePassword_change__submit__gx9kO"};